module.exports = __webpack_public_path__ + "img/2.59eb106f.jpg";